/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Button,
  CustomInput,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  currencyFormatter,
  roundToTwoDecimals,
} from "../../../../_services/currencyFormatter";
import Moment from "react-moment";
import { getDurationInHours } from "../../../Activity/Components/EditActivityModal";
import { api, userService } from "../../../../_services";

const UnassignedExpensesModal = ({
  showModal,
  toggleModal,
  unassignedExpenses,
  setUnassignedExpenses,
  invoiceId,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [isSaving, setIsSaving] = useState(false);
  const columns = [
    {
      dataField: "expenseId",
      text: "Include",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cellContent, row, i, extraData) => {
        return (
          <CustomInput
            id={`include-${row.expenseId}`}
            name={`include-${row.expenseId}`}
            type="checkbox"
            checked={!!row.isSelectedToIncludeInInvoice}
            onChange={() => {
              setUnassignedExpenses(
                extraData.map((expense) =>
                  expense.expenseId === row.expenseId
                    ? {
                        ...expense,
                        isSelectedToIncludeInInvoice:
                          !expense.isSelectedToIncludeInInvoice,
                      }
                    : expense,
                ),
              );
            }}
          />
        );
      },
      footer: "",
      formatExtraData: unassignedExpenses,
    },
    {
      dataField: "matterName",
      text: "Matter",
      sort: true,
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    {
      dataField: "expenseName",
      text: "Expense Description",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "expenseDate",
      text: "Date",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
    },
    {
      dataField: "expenseAmount",
      text: "Amount",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
      formatter: (cellContent, row) => {
        return currencyFormatter(currentUser.currencySymbol, cellContent, true);
      },
    },
  ];

  const save = async () => {
    setIsSaving(true);
    var requests = [];
    unassignedExpenses
      .filter((x) => x.isSelectedToIncludeInInvoice)
      .forEach((expense) => {
        requests.push(
          api.updateExpense(
            { ...expense, invoiceId: invoiceId },
            currentUser.userId,
          ),
        );
      });
    if (requests.length > 0) {
      await Promise.all(requests);
      reload();
    }
    setIsSaving(false);
    toggleModal();
  };

  return (
    <Modal size="xl" isOpen={showModal} toggle={toggleModal} backdrop="static">
      <ModalHeader toggle={toggleModal}>Unassigned Expenses</ModalHeader>
      <ModalBody>
        <p>{unassignedExpenses.length} expenses are unassigned.</p>
        <Button
          color="primary"
          onClick={() => {
            if (unassignedExpenses.every((x) => x.isSelectedToIncludeInInvoice)) {
              setUnassignedExpenses((prev) =>
                prev.map((x) => ({
                  ...x,
                  isSelectedToIncludeInInvoice: false,
                })),
              );
            } else {
              setUnassignedExpenses((prev) =>
                prev.map((x) => ({ ...x, isSelectedToIncludeInInvoice: true })),
              );
            }
          }}
        >
          {unassignedExpenses.every((x) => x.isSelectedToIncludeInInvoice)
            ? "Unselect All"
            : "Select All"}
        </Button>
        <BootstrapTable
          bordered={false}
          striped
          responsive
          bootstrap4
          keyField="expenseId"
          data={unassignedExpenses}
          columns={columns}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={toggleModal}>
          Close
        </Button>
        <Button
          color="primary"
          onClick={save}
          disabled={
            !unassignedExpenses.some((x) => x.isSelectedToIncludeInInvoice) ||
            isSaving
          }
        >
          Include Selected in Invoice
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UnassignedExpensesModal;
